import React, { Suspense, lazy } from 'react';
import Loader from '~components/main-loader';

const ThemeReportsPage = lazy(() => import('./index'));

function ThemeReportsPageLazy(props) {
    return (
        <Suspense fallback={<Loader />}>
            <ThemeReportsPage {...props} />
        </Suspense>
    );
}

export default ThemeReportsPageLazy;
export { ThemeReportsPageLazy };



// WEBPACK FOOTER //
// ./src/routes/main/theme-reports-page/lazy.js